import { Roles } from 'components/users-and-access';

/** @ngInject */
export default function rolesRouter($stateProvider) {
    const rolesState = {
        url: '/roles',
        views: {
            contentBody: {
                component: Roles.Component.selector
            }
        }
    };

    $stateProvider
        .state('main.users-and-access.roles', rolesState);
}



// WEBPACK FOOTER //
// ./app/components/users-and-access/roles/roles.router.js